var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar-logo-container" },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          _vm.collapse
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  staticClass: "sidebar-logo-link",
                  attrs: { to: "/home" },
                },
                [
                  _vm.logo
                    ? _c("img", {
                        staticClass: "sidebar-logo simbolo",
                        attrs: {
                          src: "/logo/dmpeople-simbolo-navy-pontomarca.svg",
                        },
                      })
                    : _c("h1", { staticClass: "sidebar-title" }, [
                        _vm._v(_vm._s(_vm.title) + " "),
                      ]),
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  staticClass: "sidebar-logo-link",
                  attrs: { to: "/home" },
                },
                [
                  _vm.logo
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        attrs: {
                          src: "/logo/dmpeople-horizontal-negativa.svg",
                        },
                      })
                    : _vm._e(),
                  _c("h1", { staticClass: "sidebar-title" }, [
                    _vm._v(_vm._s(_vm.title) + " "),
                  ]),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }